const SECRET_KEY_PARTS = [
  "password",
  "secret",
  "token",
  "api_key",
  "apikey",
  "private_key",
  "credential",
  "client_secret",
  "refresh_token",
  "service_account",
  "authorization",
];

function isSecretKey(key: string): boolean {
  const normalized = key.trim().toLowerCase().replace(/-/g, "_");
  return SECRET_KEY_PARTS.some((part) => normalized.includes(part));
}

function isEmpty(value: unknown): boolean {
  if (value == null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value as object).length === 0;
  return false;
}

export function redactConfiguration(value: unknown, depth = 0): unknown {
  if (depth > 8) return "<truncated>";
  if (Array.isArray(value)) {
    const redacted = value.slice(0, 40).map((item) => redactConfiguration(item, depth + 1));
    if (value.length > 40) {
      redacted.push({ _truncated: true, omitted: value.length - 40 });
    }
    return redacted;
  }
  if (value && typeof value === "object") {
    const redacted: Record<string, unknown> = {};
    const entries = Object.entries(value as Record<string, unknown>);
    entries.slice(0, 80).forEach(([key, item]) => {
      redacted[key] = isSecretKey(key)
        ? isEmpty(item)
          ? "<empty>"
          : "<provided>"
        : redactConfiguration(item, depth + 1);
    });
    if (entries.length > 80) redacted._truncated = true;
    return redacted;
  }
  if (typeof value === "string") {
    if (value.includes("-----BEGIN")) return "<provided>";
    return value.length > 2000 ? `${value.slice(0, 2000)}…` : value;
  }
  if (typeof value === "number" || typeof value === "boolean" || value == null) {
    return value;
  }
  return String(value).slice(0, 500);
}
